import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import _ from 'lodash';
import queryString from 'query-string';
import Alert from '../../utils/Alert';
import InventoryList from '../../components/reports/InventoryList';
import Spinner from '../../components/generics/Spinner';
import ReportHeader from '../../components/generics/ReportHeader';
import Filter from '../../components/generics/Filter';
import NoPermissionMessage from '../../components/generics/NoPermissionMessage';
import Modal from '../../components/generics/Modal';

import {
  deleteInventory,
  deleteInventorySuccess,
  deleteInventoryFailure,
  fetchBrands,
  fetchBrandsSuccess,
  fetchBrandsFailure,
} from "../../store/inventories/actions";
import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";
import { fetchInventories, fetchInventoriesSuccess, fetchInventoriesFailure } from "../../store/reports/actions";

import { getItems } from "../../store/inventories/api";
import { fetchIngredientsReportCSV } from "../../store/reports/api";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class InventoryListContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      isLoadingSearch: false,
      selectedItem: undefined,
      selectedItem_to_finish: undefined,
      selectedStation: undefined,
      selectedBrand: undefined,
      openModal: false,
      selectedPlant: '',
      selectedLot: '',
    }

    this.alertRef = React.createRef();

    this.loadSearchOptions = _.debounce(this.searchItems, DEBOUNCE_SEARCH);

    this.changeSearch = _.debounce(() => {
      this.updateResults();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const selectedItem = params.item ? { value: params.item } : undefined;
    const selectedStation = params.station ? params.station : undefined;
    const selectedBrand = params.brand ? params.brand : undefined;
    const currentPage = params.page ? params.page : STARTING_PAGE;
    const selectedPlant = params.plant ? params.plant : this.state.selectedPlant;
    const selectedLot = params.lot ? params.lot : this.state.selectedLot;

    // Fetch initial page
    this.setState({ currentPage, selectedItem, selectedStation, selectedBrand, selectedPlant, selectedLot }, () => {
      this.props.fetchInventories(
        currentPage,
        selectedItem ? selectedItem.value : undefined,
        selectedStation,
        selectedBrand,
        selectedPlant,
        selectedLot
      );
    });

    // Fetch stations
    if (!this.props.stationsList.stations || this.props.stationsList.stations.length === 0) {
      this.props.fetchStations();
    }
    // Fetch brands
    if (!this.props.brandsList.brands || this.props.brandsList.brands.length === 0) {
      this.props.fetchBrands();
    }
  }

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------
  updateResults = () => {
    const { selectedItem, selectedStation, selectedBrand, currentPage, selectedPlant, selectedLot } = this.state;
    this.props.fetchInventories(
      currentPage,
      selectedItem ? selectedItem.value : undefined,
      selectedStation,
      selectedBrand,
      selectedPlant,
      selectedLot
    );
    let params = {};
    if (selectedItem) params.item = selectedItem.value;
    if (selectedStation) params.station = selectedStation;
    if (selectedBrand) params.brand = selectedBrand;
    if (selectedPlant) params.plant = selectedPlant;
    if (selectedLot) params.lot = selectedLot;
    params.page = currentPage;
    this.props.history.push({ search: queryString.stringify(params) });
  };

  onSearchChange = (item) => {
    let selectedItem = item ? item : undefined;
    this.setState({ selectedItem, currentPage: STARTING_PAGE }, () => {
      this.updateResults();
    });
  };

  searchItems = (input, callback) => {
    this.setState({isLoadingItems: true});
    let options = [];
    getItems(input).then((res) => {
      res.data.results.map((item) => {
        options.push({value:item.id, label:item.name});
        return true;
      });
      callback(options);
      this.setState({isLoadingItems: false, selectedItem: this.state.selectedItem});
    }).catch((err) => {
      this.setState({isLoadingItems: false});
    });
  };

  onStationChange = (event) => {
    let selectedStation = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ selectedStation, currentPage: STARTING_PAGE }, () => {
      this.updateResults();
    });
  };

  onBrandChange = (event) => {
    let selectedBrand = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ selectedBrand, currentPage: STARTING_PAGE }, () => {
      this.updateResults();
    });
  };

  onPlantChange = (event) => {
    const selectedPlant = event.target.value ? event.target.value : "";
    this.setState({ selectedPlant }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const selectedLot = event.target.value ? event.target.value : "";
    this.setState({ selectedLot }, () => {
      this.changeSearch();
    });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let currentPage = data.selected + 1;
    if(currentPage !== this.state.currentPage){
      this.setState({ currentPage }, () => {
          this.updateResults();
      });
    };
  };

  onInventoryDelete = (inventoryId, deleteMessage, waste_category) => {
    var data = new FormData();
    if (deleteMessage) { data.append('delete_message', deleteMessage); }
    if (waste_category) { data.append('waste_category', waste_category); }
    this.props.deleteInventory(inventoryId, this.props, data, this.alertRef);
    this.updateResults();
  };

  empty_item = () => {
    this.setState({openModal: false});
    //number 8 indicates that "this item is no longer in inventory"
    this.onInventoryDelete(this.state.selectedItem_to_finish, "Product finished", 8)
  };

  openModal = (id) => {
    this.setState({openModal: true, selectedItem_to_finish: id})
  };

  loadCsv = () => {
    const { selectedItem, selectedStation, selectedBrand, selectedPlant, selectedLot } = this.state;
    let fileName = `IngredientsReport.csv`;
    this.setState({ csvIsLoading: true });
    fetchIngredientsReportCSV(
      selectedItem ? selectedItem.value : undefined,
      selectedStation,
      selectedBrand,
      true,
      true,
      selectedPlant,
      selectedLot
    )
      .then((r) => {
        let blob = new Blob([r.data], { type: "text/csv" });
        let link = document.createElement("a");
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        link.click();
        document.body.removeChild(link);
        this.setState({
          csvIsLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          csvIsLoading: false,
        });
      });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
      return (
        <div className="animated fadeIn">
          <Alert ref={this.alertRef}/>
          <div className="card">
            <ReportHeader title='Active ingredients' actionTitle='Export CSV' actionClass='btn btn-primary m-0'
              csvLoading={this.state.csvIsLoading}
              fromFile={true}
              loadCsv={this.loadCsv}
            />
            <Filter
              searchDropdownLabel="Search Item"
              searchDropdownPlaceholder="Search item"
              searchDropdownVal={this.state.selectedItem}
              onSearchDropdownChange={this.onSearchChange}
              isLoadingSearchDropdown={this.state.isLoadingSearch}
              loadSearchDropdownOptions={this.loadSearchOptions}
              dropdownLabel="Station"
              dropdownPlaceholder="Station"
              dropdownVal={this.state.selectedStation}
              onDropdownChange={this.onStationChange}
              dropdownByElementId
              dropdownOptions={this.props.stationsList.stations.results}
              dropdownLabel2="Brand"
              dropdownPlaceholder2="Brand"
              dropdownVal2={this.state.selectedBrand}
              onDropdownChange2={this.onBrandChange}
              dropdownByElementId2
              dropdownOptions2={this.props.brandsList.brands.results}
              searchLabel3="Plant"
              searchPlaceholder3="Search by plant"
              searchVal3={this.state.selectedPlant}
              onSearchChange3={this.onPlantChange}
              searchLabel4="Lot"
              searchPlaceholder4="Search by lot"
              searchVal4={this.state.selectedLot}
              onSearchChange4={this.onLotChange}
            />
          </div>

          <div className="card">
            <div className="card-block p-0">
              <table className="table table-striped table-bordered datatable mb-0">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th title="Item name">Item</th>
                    <th className="hidden-xs-down">Station</th>
                    <th className="hidden-xs-down">Brand</th>
                    <th>Qty</th>
                    <th className="hidden-xs-down">Date Received</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <InventoryList inventories={this.props.inventoryList} is_ingredient={true} openModal={this.openModal}/>
              </table>
              {this.props.inventoryList.pages > 1 &&
                <ReactPaginate  pageCount={this.props.inventoryList.pages}
                                pageRangeDisplayed={2}
                                marginPagesDisplayed={1}
                                previousLabel="<"
                                nextLabel=">"
                                onPageChange={this.handlePageRequest}
                                initialPage={this.state.currentPage-1}
                                disableInitialCallback={true}
                                containerClassName="pagination"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                activeClassName="page-item active"
                                previousClassName="paginate_button previous"
                                nextClassName="paginate_button next"
                                disabledClassName="page-item disabled"
                                forcePage={this.state.currentPage-1}/>
              }
            </div>
          </div>
          { this.props.inventoryList.loading || this.state.isLoading ||
            this.props.stationsList.loading || this.props.brandsList.loading ?
            <Spinner />
          :
            null
          }
          <Modal
            closeModal={() => this.setState({openModal: false})}
            isModalOpen={this.state.openModal}
            onConfirm={this.empty_item}
            onCancel={() => this.setState({openModal: false})}
            header="Please confirm"
            content="The following action will mark the inventory item as finished. In case
            the item is not finished but has to be removed from inventory, please cancel and click on the item's id number."
            onConfirmButtonText="Confirm"
            onCancelButtonText="Cancel"
          />
        </div>
      )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    inventoryList: state.reports.inventoryList,
    stationsList: state.sessions.stationsList,
    brandsList: state.inventories.brandsList,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInventories: (page, item, station, brand, plant, lot) => {
      dispatch(fetchInventories(page, true, item, station, brand, true, null, plant, lot)).payload.then((response) => {
        dispatch(fetchInventoriesSuccess(response.data))
      }, (error) => {
        dispatch(fetchInventoriesFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
    fetchBrands: () => {
      dispatch(fetchBrands()).payload.then((response) => {
        dispatch(fetchBrandsSuccess(response.data))
      }, (error) => {
        dispatch(fetchBrandsFailure(error));
      });
    },
    deleteInventory: (id, props, data, alertRef) => {
      dispatch(deleteInventory(id, data)).payload.then((response) => {
        dispatch(deleteInventorySuccess(response.data));
        alertRef.current.sendAlert(`Inventory ${id} successfully deleted`, "success");
      }, (error) => {
        dispatch(deleteInventoryFailure(error));
        alertRef.current.sendAlert(`Cannot delete Inventory ${id}`);
      });
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InventoryListContainer));
